// Pure helpers for column-header long-press reordering. No DOM/React.

// Long-press hold time and movement slop before a press is treated as a drag.
export const LONG_PRESS_MS = 400;
export const MOVE_TOLERANCE_PX = 8;

// Move `draggedId` into `targetId`'s slot within `columnOrder`.
// Mirrors mantine-react-table's internal reorderColumn (splice by id).
// Pure: returns a new array, or the original (same ref) if either id is absent.
export const reorderColumn = (draggedId, targetId, columnOrder) => {
  const from = columnOrder.indexOf(draggedId);
  const to = columnOrder.indexOf(targetId);
  if (from === -1 || to === -1) return columnOrder;
  const next = [...columnOrder];
  next.splice(to, 0, next.splice(from, 1)[0]);
  return next;
};

// True when the pointer has moved farther than `tolerance` px from its
// start point on either axis.
export const pointMovedBeyond = (startX, startY, x, y, tolerance = MOVE_TOLERANCE_PX) =>
  Math.abs(x - startX) > tolerance || Math.abs(y - startY) > tolerance;

// rects: [{ id, left, right }] in viewport coordinates. Returns the id of the
// column whose horizontal span contains `clientX`, or null.
export const findColumnAtX = (rects, clientX) => {
  const hit = rects.find(r => clientX >= r.left && clientX <= r.right);
  return hit ? hit.id : null;
};
